import React, { FC } from 'react'

interface Props {
  email: string
  firstName: string
  lastName: string
}

// Brief transitional state: shown for the moment between the sign-up
// mutation completing and Profile's own currentCustomer refetch swapping
// this component out entirely.
export const LoggedCustomerView: FC<Props> = ({ firstName, lastName, email }) => (
  <p className="user-profile-login__description">
    {firstName} {lastName}
    <br />
    {email}
  </p>
)
